import React from 'react';
import { Typography, Box, Container, Button } from '@mui/material';
import Seo from '../Seo';

const SummerCruise = () => {
  return (
    <Container maxWidth="lg">
      <Seo
        title="Marriage Ministry Cruise 2026"
        description="Join the NMZ Marriage Ministry for the 2026 cruise — a getaway to strengthen marriages in faith and fellowship."
        path="/cruise2026"
      />
      <Box
        sx={{
          mt: 2,
          textAlign: 'center',
          py: 6,
          mb: 0,
          backgroundImage: `url('${require('./cruise.jpg')}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'orange',
        }}
      >
        <Typography
          variant="h5"
          component="h2"
          sx={{
            borderRadius: 2,
            textShadow: '2px 2px 4px rgba(0, 0, 0)',

            mb: 1,
            color: 'white',
          }}
        >
          NMZ Marriage Ministry
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              borderRadius: 2,
              textShadow: '2px 2px 4px rgba(0, 0, 0)',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              width: 'fit-content',
              pl: 2,
              pr: 2,
            }}
          >
            Group Cruise Summer 2026
          </Typography>
        </Box>
        <Typography
          variant="caption"
          gutterBottom
          sx={{
            borderRadius: 2,
            textShadow: '2px 2px 4px rgba(0, 0, 0)',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            width: 'fit-content',
            pl: 2,
            pr: 2,
            color: 'white',
            fontSize: '1.2rem',
          }}
        >
          June 8th - June 12th, 2026
        </Typography>
      </Box>

      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="body1" paragraph>
          The NMZ Marriage Ministry is planning a group cruise in Summer 2026!
          <br />
          This will be a time to retreat, fellowship, build connections, and
          have some fun. This is open to all Married New Mt Zion Members.
          Couples are also welcome to bring their children, if they choose. The
          cruise ship will have activities for all ages, so the whole family can
          enjoy the experience.
          <br />
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Itinerary:</strong>{' '}
          <a
            href="https://www.royalcaribbean.com/itinerary/4-night-bahamas-perfect-day-cruise-from-orlando-port-canaveral-on-utopia-UT4BH339?country=USA&currencyCode=USD&sailDate=2026-06-08&packageCode=UT4BH339"
            target="_blank"
            rel="noopener noreferrer"
          >
            4 Night Bahamas & Perfect Day Cruise from Port Canaveral (Orlando)
          </a>
          <br />
          <strong>Cruise Date:</strong> June 8th - June 12th, 2026
          <br />
          <strong>Departure Port:</strong> Orlando (Port Canaveral), Florida
          <br />
          <strong>Ship:</strong> Royal Caribbean: Utopia of the Seas
          <br />
          <strong>Cost:</strong> Starting at $891 per person (pricing may vary
          based on room selection and availability). $100 deposit per person is
          required to secure your spot.
          <br />
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          Are interested in joining us? If so, please follow the steps below:{' '}
        </Typography>
        <Typography variant="body1" paragraph>
          1. Review the cruise details and itinerary on the{' '}
          <a
            href="https://www.royalcaribbean.com/itinerary/4-night-bahamas-perfect-day-cruise-from-orlando-port-canaveral-on-utopia-UT4BH339?country=USA&currencyCode=USD&sailDate=2026-06-08&packageCode=UT4BH339"
            target="_blank"
            rel="noopener noreferrer"
          >
            Royal Caribbean website
          </a>
          <br />
          2. Call the Royal Caribbean Group Cruise Department at{' '}
          <a href="tel:1-800-465-3595">1-800-465-3595</a> to reserve your cabin.
          (Only a $100 deposit is required to secure your spot). You may also
          book directly online through the Royal Caribbean website, but calling
          may provide more personalized assistance and a $50 onboard credit.
          <br />
          3. When booking, please provide the group name {`"`}
          <b>NMZ Marriage</b>
          {`" `} and the Group Number {`"`}
          <b>3255208</b>
          {`" `}
          to ensure you are included in our group and you get the $50 onboard
          credit.
          <br />
          4. After booking, please fill out the registration form below to let
          us know you are joining the cruise. This will help us keep track of
          participants and plan group activities.
          <br />
        </Typography>
        <Box>
          <Button
            variant="contained"
            href="https://forms.gle/ccNURASueaUc7arb7"
            target="_blank"
            rel="noopener noreferrer"
          >
            Fill Register Form
          </Button>
        </Box>
        <br />
        <Typography variant="body1" paragraph>
          If you have any questions or need assistance with booking, please
          contact us at{' '}
          <a href="mailto:rukychase@gmail.com" target="_blank" rel="noreferrer">
            rukychase@gmail.com
          </a>
        </Typography>
      </Box>
    </Container>
  );
};

export default SummerCruise;
